import { LoggingService } from "../helpers/logging-service";
import Nano from "nano";
export class FuseInitializerCouch {
    constructor({ couchConfig }) {
        Object.defineProperty(this, "_databaseInstance", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_documentScope", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "couchConfig", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.couchConfig = couchConfig;
    }
    getFullDbUrl(config) {
        const protocol = config?.protocol || "http";
        const dbUrlPart = [`${protocol}://`];
        if (config?.username && config.password) {
            dbUrlPart.push(config.username);
            dbUrlPart.push(`:${config.password}@`);
        }
        dbUrlPart.push(config.host);
        if (config?.port) {
            dbUrlPart.push(`:${config.port}`);
        }
        return dbUrlPart.join("");
    }
    async deleteIndex({ ddoc, name }) {
        const path = ["_index", ddoc, "json", name].join("/");
        const result = await this._databaseInstance.relax({
            db: this.couchConfig.databaseName,
            method: "DELETE",
            path,
            content_type: "application/json",
        });
        return result;
    }
    async getIndexes() {
        const result = await this.getInstance().request({
            db: this.couchConfig.databaseName,
            method: "GET",
            path: "_index",
            content_type: "application/json",
        });
        LoggingService.log({ indexes: result });
        return result;
    }
    getDocInstance() {
        if (!this._documentScope) {
            const n = this.getInstance();
            const db = n.db.use(this.couchConfig.databaseName);
            this._documentScope = db;
        }
        return this._documentScope;
    }
    async checkDatabaseExists(databaseName) {
        const checkDbExistResult = await this.getInstance().request({
            db: databaseName || this.couchConfig.databaseName,
            method: "HEAD",
            content_type: "application/json",
        });
        LoggingService.log(JSON.stringify({ checkDbExistResult }, null, 2));
        return checkDbExistResult;
    }
    async createDatabase() {
        return await this.getInstance().db.create(this.couchConfig.databaseName, { partitioned: true });
    }
    getInstance() {
        if (!this._databaseInstance) {
            this._databaseInstance = Nano(this.getFullDbUrl(this.couchConfig));
        }
        return this._databaseInstance;
    }
}
